// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationButton_root___R2PQ","active":"NavigationButton_active__sXsBr"};